import styled from 'styled-components';
import { Button, DeleteIcon, PreviousIcon, theme } from '@kvdbil/components';

const PreviewContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  background: ${theme.colors.background.dark};
  z-index: 99;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ActionBar = styled.div`
  position: absolute;
  width: 100%;
  background: rgb(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
`;

const TopBar = styled(ActionBar)`
  height: 40px;
  top: 0;
  justify-content: space-between;
  @media (orientation: portrait) {
    height: 56px;
  }
`;

const TopBarDeleteButton = styled(Button)`
  @media (orientation: portrait) {
    display: none;
  }
`;

const BottomBar = styled(ActionBar)`
  height: 64px;
  bottom: 0;
  justify-content: right;
  @media (orientation: landscape) {
    display: none;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
  }
`;

interface Props {
  fileUrl: string | null;
  deleteImage: () => void;
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}

export const PreviewImage = ({
  fileUrl,
  deleteImage,
  isOpen,
  setIsOpen,
}: Props) => {
  if (!fileUrl || !isOpen) {
    return null;
  }

  return (
    <PreviewContainer>
      <TopBar>
        <Button
          color="primary"
          variant={'flat'}
          onClick={() => setIsOpen(false)}
          data-testid="close-button"
        >
          <PreviousIcon width={24} height={24} color={'#ffffff'} />
        </Button>
        <TopBarDeleteButton
          color="primary"
          variant={'flat'}
          onClick={deleteImage}
          data-testid={'remove-button'}
        >
          <DeleteIcon width={24} height={24} color={'#ffffff'} />
        </TopBarDeleteButton>
      </TopBar>
      <ImageContainer>
        <img src={fileUrl} alt={'preview'} data-testid="preview-image" />
      </ImageContainer>
      <BottomBar>
        <Button color="primary" variant={'flat'} onClick={deleteImage}>
          <DeleteIcon width={24} height={24} color={'#ffffff'} />
        </Button>
      </BottomBar>
    </PreviewContainer>
  );
};
